<template>
  <div class="editable-text-component" @mouseenter="adjustBtnHeight">
    <div v-if="isEditMode" v-click-outside="hideAfterOutsideClick" class="edit-mode">
      <multiselect
        v-if="isTag"
        v-model="selectedTags"
        v-focus
        track-by="id"
        label="name"
        :multiple="true"
        :taggable="taggable"
        :options="multiSelectOptions"
        select-label=""
        :tag-placeholder="$t('tag.placeholder.new_tag')"
        :placeholder="$t('tag.placeholder.select_tags')"
        :hide-selected="true"
        :close-on-select="false"
        @tag="addTag"
      >
        <span slot="noOptions">{{ $t('common.no_options') }}</span>
        <span slot="noResult">{{ $t('common.no_data') }}</span>
      </multiselect>
      <span v-else class="text-mode">
        <input id="input-text" v-model="inputText" v-focus type="text" />
      </span>
      <div class="dropdown">
        <el-button-group>
          <el-button type="primary" size="mini" icon="el-icon-check" @click="saveInputValue"></el-button>
          <el-button icon="el-icon-close" size="mini" @click="cancelInput"></el-button>
        </el-button-group>
      </div>
    </div>
    <div v-else class="show-mode" @click="changeEditMode(true)">
      <div class="input-border" :style="isEmptyObject(value) ? 'height: 32px' : ''">
        <div v-if="isEmptyObject(value)" style="margin: 6px 0">{{ noData }}</div>
        <div v-else>
          <div v-if="isTag" style="margin: 3px 0">
            <el-tag v-for="tag in value" :key="tag.id">{{ tag.name }}</el-tag>
          </div>
          <div v-else style="margin: 6px 0">{{ value }}</div>
        </div>
      </div>
      <button type="button" class="editable-text-btn">
        <img src="/icons/pencil.svg" width="13" height="13" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  directives: {
    focus: {
      inserted: function(el) {
        el.focus()
      }
    }
  },
  props: {
    value: {
      type: [Array, String],
      default: ''
    },
    multiSelectOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    noData: {
      type: String,
      default: ''
    },
    isTag: {
      type: Boolean,
      default: true
    },
    taggable: {
      type: Boolean,
      default: true
    },
    newTag: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function() {
    return {
      isEditMode: false,
      inputText: '',
      selectedTags: []
    }
  },
  watch: {
    value(val) {
      this.value = val
      if (this.isTag) {
        this.selectedTags = val.slice()
      } else {
        this.inputText = val
      }
    },
    newTag(val) {
      this.multiSelectOptions.push(val)
      this.selectedTags.push(val)
    }
  },
  methods: {
    saveInputValue: function() {
      if (this.isTag) {
        if (
          this.selectedTags
            .map(tag => tag.name)
            .sort()
            .join('') !==
          this.value
            .map(tag => tag.name)
            .sort()
            .join('')
        ) {
          this.$emit('confirm', this.selectedTags)
          this.$emit('input', this.selectedTags)
        }
      } else {
        if (this.inputText !== this.value) {
          this.$emit('confirm', this.inputText)
          this.$emit('input', this.inputText)
        }
      }
      this.changeEditMode(false)
    },
    changeEditMode: function(status) {
      this.isEditMode = status
    },
    cancelInput: function() {
      if (this.isTag) {
        this.selectedTags = this.value.slice()
      } else {
        this.inputText = this.value
      }
      this.changeEditMode(false)
    },
    hideAfterOutsideClick: function(event) {
      // 兼容 safari 获取鼠标事件的属性
      let paths = event.path || event.composedPath()
      if (!this.hasEditableText(paths)) {
        this.saveInputValue()
      }
    },
    hasEditableText: function(paths) {
      var self = this
      var matched = false
      paths.forEach(function(item) {
        if (self.isEditableText(item)) {
          matched = true
          return true
        }
      })
      return matched
    },
    isEditableText: function(path) {
      return $(path).hasClass('editable-text-component')
    },
    addTag(newTag) {
      const tag = {
        name: newTag
      }
      this.$emit('add-tag', tag)
    },
    adjustBtnHeight() {
      let height = $('.input-border').height()
      $('.editable-text-btn').height(height)
    }
  }
}
</script>

<style lang="scss" scoped>
.editable-text-component {
  display: inline;
  float: left;
  margin-top: -7px;
  margin-left: -14px;

  // custom multiselect style
  ::v-deep .multiselect {
    height: unset !important;
    min-height: unset !important;
    font-size: 12px;
    .multiselect__tags {
      min-height: 32px !important;
      padding: 0 40px 0 13px !important;
      border-radius: 5px 5px 0 5px !important;
      border: 1px solid #ccc;
      font-size: 12px;
      .multiselect__tag {
        color: #414b56;
        background: #ebeced;
        margin: 5px 8px -2px 0;
        border-radius: 4px;
        z-index: 999;
        .multiselect__tag-icon {
          margin-top: -1px;
          &:hover {
            background: #ebeced;
          }
          &:after {
            color: #414b56;
            font-size: 12px;
          }
        }
      }
      .multiselect__input {
        margin: 5px 0 !important;
        padding-left: 0;
        width: unset !important;
        position: unset !important;
        font-size: 13px !important;
      }
      .multiselect__placeholder {
        display: none;
      }
    }
    .multiselect__select {
      top: -1px;
      &:before {
        content: '';
        display: inline-block;
        width: 7px;
        height: 7px;
        margin-top: 7px;
        border-top: none;
        border-left: none;
        border-bottom: 1px solid #41c981;
        border-right: 1px solid #41c981;
        transform: rotate(45deg);
        position: unset;
      }
    }
    .multiselect__option--highlight {
      background: #555f72;
      &:after {
        position: relative;
        line-height: unset;
        padding: 0 60px 0 3px;
        background: #555f72;
      }
    }
    .multiselect__option {
      padding: 12px !important;
      min-height: 40px !important;
    }
  }
}

.show-mode {
  position: relative;

  .input-border {
    border: 1px transparent solid;
    border-radius: 5px 0 0 5px;
    padding: 0 13px;
  }

  .editable-text-btn {
    width: 30px;
    height: 32px;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 0;
    right: -29px;
    background: #fff;
    border: 1px #ccc solid;
    border-radius: 0 4px 4px 0;
    outline: none;
    z-index: 1;

    i {
      position: absolute;
      top: 7px;
      left: 7px;
    }
  }
}

.show-mode:hover {
  .input-border {
    transition: all 0.3s;
    border: 1px #ccc solid;
    cursor: text;
  }
  .editable-text-btn {
    transition: visibility 0.4s, opacity 0.4s;
    visibility: visible;
    opacity: 1;
  }
}

.edit-mode {
  position: relative;

  .dropdown {
    position: absolute;
    margin-top: -1px;
    right: 0;
    width: 48px;
    // border: 1px solid #cdd1da;
    border-radius: 0 0 4px 4px;
    z-index: 999;
    background: #fafafa;

    .el-button {
      padding: 5px;
    }
  }

  .text-mode {
    input {
      width: 100%;
      height: 32px;
      padding: 0 13px;
      border: 1px #cdd1da solid;
      border-radius: 5px 5px 0 5px;
      outline: none;
    }
  }
}
</style>
